import VoucherInput from "./voucher-input"
import withVoucherActions from "./with-voucher-actions"

const Voucher = withVoucherActions(VoucherInput)

export default Voucher
